import React from "react";
import { FaGithub } from "react-icons/fa";

const HeaderSocials = () => {
  return (
    <div className="header__socials">
      <a href="https://github.com/h-shark">
        <FaGithub />
      </a>
    </div>
  );
};

export default HeaderSocials;
